import { db } from "./firebase";
import { doc, setDoc } from "firebase/firestore";

export const updateEntity = async (entity, entityId, fields) => {
  fields = {
    ...fields,
    // updatedAt: serverTimestamp(),
  };
  await setDoc(doc(db, entity, entityId), fields, { merge: true });
};
